import styled from 'styled-components';

import { IconWrapper } from '@dreryk/react-components';

export const StyledTreatmentDaysCountTooltipIcon = styled(IconWrapper)`
   width: 14px;
   height: 14px;
   margin-left: 3px;
`;

StyledTreatmentDaysCountTooltipIcon.displayName = 'StyledTreatmentDaysCountTooltipIcon';
